import { ajaxRetry } from '../ajaxRetry';

import { ConsumedHandoffSession, HandoffSession } from '../../models/handoffSession';
import { base, createApiURL, defaultHeaders, ResponseObj } from './base';

type CreateHandoffSessionPayload = {
  credentialsId?: string;
  providerName: string;
  userAccessToken: string;
  sessionId: string;
};

export const createHandoffSession = (
  payload: CreateHandoffSessionPayload
): Promise<ResponseObj<HandoffSession>> => {
  return ajaxRetry({
    data: JSON.stringify(payload),
    headers: base.headers(),
    method: 'POST',
    url: createApiURL(`/link/v1/handoff-sessions`),
  });
};

export type GetHandoffSessionPayload = {
  handoffSessionId: string;
};

export const getHandoffSession = async ({ handoffSessionId }: GetHandoffSessionPayload) => {
  return ajaxRetry<HandoffSession, undefined>({
    headers: base.headers(),
    method: 'GET',
    url: createApiURL(`/link/v1/handoff-sessions/${handoffSessionId}`),
  });
};

export type UpdateHandoffSessionPayload = {
  credentialsId?: string;
  transferId?: string;
  handoffSessionId: string;
};

export const updateHandoffSession = async ({
  credentialsId,
  transferId,
  handoffSessionId,
}: UpdateHandoffSessionPayload): Promise<ResponseObj<HandoffSession>> => {
  return ajaxRetry<HandoffSession>({
    headers: base.headers(),
    method: 'PUT',
    data: JSON.stringify({ credentialsId, transferId }),
    url: createApiURL(`/link/v1/handoff-sessions/${handoffSessionId}`),
  });
};

export type ConsumeHandoffSessionPayload = {
  handoffSessionId: string;
};

export const consumeHandoffSession = async ({
  handoffSessionId,
}: ConsumeHandoffSessionPayload): Promise<ResponseObj<ConsumedHandoffSession>> => {
  return ajaxRetry<ConsumedHandoffSession>({
    // We are not using base.headers() as that is NOT setup yet.
    // This is OK because the handoff is meant to be unauthenticated
    headers: defaultHeaders,
    method: 'POST',
    url: createApiURL(`/link/v1/handoff-sessions/${handoffSessionId}/consume`),
  });
};

export type CreateUrlHandoffSessionRequest = {
  credentialsId?: string;
  providerName: string;
  userAccessToken: string;
  sessionId: string;
  url: string;
};

export const createUrlHandoffSession = (payload: CreateUrlHandoffSessionRequest) => {
  return ajaxRetry<HandoffSession, undefined>({
    data: JSON.stringify(payload),
    headers: base.headers(),
    method: 'POST',
    url: createApiURL(`/link/v1/handoff-sessions`),
  });
};

export const consumeUrlHandoffSession = async (urlHandoffSessionId: string) => {
  return ajaxRetry<ConsumedHandoffSession, undefined>({
    headers: base.headers(),
    method: 'POST',
    url: createApiURL(`/link/v1/handoff-sessions/${urlHandoffSessionId}/consume`),
  });
};

export const updateUrlHandoffSession = async (
  urlHandoffSessionId: string,
  credentialsId: string
) => {
  return ajaxRetry<HandoffSession, undefined>({
    data: JSON.stringify({ credentialsId }),
    headers: base.headers(),
    method: 'PUT',
    url: createApiURL(`/link/v1/handoff-sessions/${urlHandoffSessionId}`),
  });
};
